import { ReactNode, useMemo } from 'react';
import { generatePath, useParams } from 'react-router-dom';

import { OrderFormsRoutes } from 'support/types';
import { PrivateRoute } from 'components/PrivateRoute/PrivateRoute';

import { AuthorizationGuard } from './AuthorizationGuard';

export const OrderFormRoute = ({ children }: { children: ReactNode }) => {
  const params = useParams();

  const loginPath = useMemo(
    () =>
      generatePath(OrderFormsRoutes.login, {
        supplierSlug: params.supplierSlug || '',
      }),
    [params.supplierSlug],
  );

  return (
    <PrivateRoute redirectTo={loginPath}>
      <AuthorizationGuard>{children}</AuthorizationGuard>
    </PrivateRoute>
  );
};
